import { format, isValid, parse } from 'date-fns'

export function prepareDateSybase(value: Date | null) {
  if (value) {
    if (!isValid(value)) return null
    return format(value, 'yyyy-MM-dd')
  }
  return null
}

export function formatValueDate(value: any, format?: string) {
  return formatValue(value, 'date', format)
}

export function formatValueDateTime(value: any) {
  return formatValue(value, 'datetime')
}

export type FieldInputType = 'text' | 'date' | 'datetime'

export function formatValue(
  value: any,
  type: FieldInputType | undefined,
  dateFormat?: string,
) {
  switch (type) {
    case 'date':
      if (value) {
        if (dateFormat) {
          return format(new Date(value), dateFormat)
        } else {
          return new Date(value).toLocaleDateString()
        }
      }
      return ''
    case 'datetime':
      const returnFormat = 'dd/MM/yyyy h:mma'
      if (!value) {
        return ''
      } else if (isValid(new Date(value))) {
        return format(new Date(value), returnFormat)
      } else if (isValid(parse(value, 'yyyy-MM-dd HH:mm:ss', new Date()))) {
        return format(
          new Date(parse(value, 'yyyy-MM-dd HH:mm:ss', new Date())),
          returnFormat,
        )
      }
      return value
    default:
      return value ?? ''
  }
}
